import mutations from './machineOperatorPermit.mutations'
import actions from './machineOperatorPermit.actions'
import getters from './machineOperatorPermit.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
